'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
class CandidateAccountDetails extends _react.Component {
  state = {
    loading: false,
    slug: document.location.pathname.split('/mon-compte-candidat/')[1]
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCandidate();
  }
  fetchCandidate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      id: state.slug
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        candidate: response.candidates[0]
      });
      component.fetchCv();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-all', {
      candidate_id: state.slug
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        cv: response.cvs[0] || {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo((0, _Routes.URL)('Home', _Routes.front_urls));
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let candidate = state?.candidate;
    let phone_number_parse;
    if (candidate?.home_phone_number && candidate?.phone_number) {
      phone_number_parse = candidate?.home_phone_number + ' / ' + candidate?.phone_number;
    } else if (candidate?.home_phone_number) {
      phone_number_parse = candidate?.home_phone_number;
    } else {
      phone_number_parse = candidate?.phone_number;
    }
    const address_line_2 = candidate?.address.line_2 !== '' ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("br", null), candidate?.address.line_2) : '';
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Mes informations"), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Nom : ", candidate?.lastname + ' ' + candidate?.firstname, " "), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Date de naissance : ", (0, _moment.default)(candidate?.birthdate).format('DD/MM/YYYY')), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Num\xE9ro de t\xE9l\xE9phone: ", phone_number_parse), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Adresse mail : ", candidate?.login, " "), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Adresse : ", /*#__PURE__*/_react.default.createElement("br", null), candidate?.address.line_1, " ", /*#__PURE__*/_react.default.createElement("br", null), address_line_2, candidate?.address.postal_code + ', ' + candidate?.address.city), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: '/modifier-mon-compte-candidat/' + candidate?.id,
      className: "c-btn"
    }, "Modifier mes informations")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Mon CV en ligne"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn",
      href: '/candidats/' + state.cv?.id,
      target: "_blank"
    }, "Visualiser mon CV en ligne"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: '/mon-cv/' + candidate?.id,
      className: "c-btn u-margin-top-20"
    }, "Modifier mon CV en ligne")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row c-account_row--actions"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.logout,
      className: "c-btn"
    }, "Se d\xE9connecter")));
    return output;
  }
}
exports.default = CandidateAccountDetails;
